import { useState, useEffect, useCallback } from 'react';

export const useTyping = (text: string, speed: number = 50, delay: number = 0) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  const startTyping = useCallback(() => {
    setIsTyping(true);
    setDisplayedText('');
  }, []);

  const stopTyping = useCallback(() => {
    setIsTyping(false);
  }, []);

  useEffect(() => {
    if (!text || isTyping) return;

    const timer = setTimeout(() => {
      startTyping();
    }, delay);

    return () => clearTimeout(timer);
  }, [text, delay, startTyping, isTyping]);

  useEffect(() => {
    if (!isTyping) return;

    let currentIndex = 0;
    const interval = setInterval(() => {
      if (currentIndex < text.length) {
        setDisplayedText(text.slice(0, currentIndex + 1));
        currentIndex++;
      } else {
        setIsTyping(false);
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, isTyping]);

  return {
    displayedText,
    isTyping,
    startTyping,
    stopTyping
  };
};
